import { useEffect, useRef, useState } from "react";
import { useLoadScript } from "@react-google-maps/api";
import { HeadLogo } from "../components/headLogo";
import { CheckpointCard } from "../presenters/checkpointCard";
import LocationInfoMessage from "../components/locationInfoMessage";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {
  apiKey,
  mapId,
  markerData,
  center,
  mapLibraries,
} from "../data/mapConfig";
function MapOverviewView({ locationInfo, images, firstName, onProfile }) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: apiKey,
    libraries: mapLibraries,
  });

  const mapRef = useRef(null);
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const [mapInitialized, setMapInitialized] = useState(false);
  const markerImageMap = useRef({});

  useEffect(() => {
    if (!isLoaded || loadError || mapInitialized) return;

    const initMap = async () => {
      const mapElement = document.getElementById("map_canvas");
      if (!mapElement) return;

      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

      mapRef.current = new google.maps.Map(mapElement, {
        center,
        zoom: 17,
        mapId,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
      });


      markerData.forEach(({ id, lat, lng, title }) => {
        const imageKey = `drawing_${id}`;
        const imageUrl = images[imageKey];

        const img = document.createElement("img");
        img.src = imageUrl;
        img.style.width = "80px";
        // img.classList.add("marker-image");
        // img.dataset.markerId = id;
        // img.style.opacity = "1";
        img.style.filter = "none";
        img.style.boxShadow = "none";
        img.style.border = "none";
        img.style.zIndex = "1"; 



        const marker = new AdvancedMarkerElement({
          map: mapRef.current,
          position: { lat, lng },
          title,
          content: img,
          zIndex: 1,
        });
        markerImageMap.current[id] = { img,marker };
        marker.addListener("click", () => {
          setSelectedLocationId((prev) => (prev === id ? null : id));
        });
      });

      setMapInitialized(true);
    };

    initMap();
  }, [isLoaded, loadError, mapInitialized, images]);

  useEffect(() => {
    Object.entries(markerImageMap.current).forEach(([id, { img,marker }]) => {
      const isSelected = selectedLocationId === id;

      if (isSelected) {
        //  img.style.position = "relative"; 
        img.style.opacity = "1";
        img.style.filter = "none";
        img.style.boxShadow = "0 0 15px 4px #3d7cf1";
        img.style.border = "3px solid #3d7cf1";
        img.style.backgroundColor = " #f9f9f9";
        img.style.borderRadius = "50%";
        img.style.transform = "scale(2)";
        marker.zIndex = 999;
      } else {
        img.style.boxShadow = "none";
        img.style.border = "none";
        img.style.borderRadius = "0%";
        img.style.transform = "scale(1)";
        marker.zIndex = 1;
        img.style.backgroundColor = "transparent";
        //  img.style.position = "relative"; 
      }
    });
  }, [selectedLocationId]);

  if (loadError) return <div>Error loading map</div>;
  if (!isLoaded) return <div>Loading...</div>;

  return (
    <div className="fixedLayout">
      <div className="mapOverview-headerContainer">
        <div className="mapOverview-profile" onClick={onProfile}>
          <HeadLogo />
          <AccountCircleIcon className="progress-back-button" />
          <div className="mapOverview-profile-text">{firstName}</div>
        </div>
      </div>

      <div id="map_canvas" className="mapOverview-map"></div>

      

      <div className="mapOverview-infoContainer">
        
        {selectedLocationId ? (
          <CheckpointCard
            location={locationInfo[selectedLocationId]}
            onDiscover={(id) => {
              window.location.hash = `#/arrivalCheck/${id}`;
            }}
          />
        ) : (
          <LocationInfoMessage />
        )}
      </div>
    </div>
  );
}

export { MapOverviewView };
